module.exports = __webpack_public_path__ + "img/seal-google-safe-browsing.d2fc09c2.svg";